export default function React_ES6() {
  return (
    <div>
      <h1>React_ES6 Component</h1>
      <p>This is the React_ES6 tutorial page.</p>
    </div>
  );
}
